import getViewType from './getViewType';

const getDateConstraint = () => {
  const today = new Date();
  const type = getViewType();

  switch (type) {
    case 'upcoming':
      return {
        minDate: today,
        maxDate: null,
      };
    case 'past':
      return {
        minDate: null,
        maxDate: today,
      };
    case 'scheduled':
    default:
      return {
        minDate: null,
        maxDate: null,
      };
  }
};

export default getDateConstraint;
